// noinspection JSUnusedGlobalSymbols

import { createApi } from '@reduxjs/toolkit/query/react';
import customBaseQuery from '@/lib/customBaseQuery';
import moment from 'moment';

const eventsBaseUrl = '/api/events';

export const eventsApi = createApi({
  reducerPath: 'eventsApi',
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    tableLists: builder.query<EventTableListResponse, EventsTableSearchParams>({
      query: (params) => ({
        url: eventsBaseUrl,
        method: 'GET',
        params,
      }),
    }),
    eventById: builder.query<CheckinEventData, number>({
      query: (id) => ({
        url: `${eventsBaseUrl}/${id}`,
        method: 'GET',
      }),
    }),
    deleteEventById: builder.mutation<{ success: boolean }, number>({
      query: (id) => ({
        url: `${eventsBaseUrl}/${id}`,
        method: 'DELETE',
      }),
    }),
    saveEvent: builder.mutation<CheckinEventData, EventPostPayload>({
      query: (body) => ({
        url: eventsBaseUrl,
        method: 'POST',
        body,
      }),
    }),
    generateQRCode: builder.mutation<{ filename: string; blob: Blob }, number>({
      query: (eventId) => ({
        url: `${eventsBaseUrl}/${eventId}/qrcode`,
        method: 'GET',
        responseHandler: async (response) => {
          const blob = await response.blob();
          // Extract filename from Content-Disposition header or use default
          const dateTime = moment().format('YYYY-MM-DD_HH-mm-ss');
          let filename = `qrcode_event-id_${eventId}_${dateTime}.pdf`;
          const contentDisposition = response.headers.get('Content-Disposition');
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
            if (filenameMatch) {
              filename = filenameMatch[1];
            }
          }
          return { filename, blob };
        },
      }),
    }),
    eventBlastEmail: builder.mutation<
      { message: string; success: boolean },
      EventBlastEmailPayload
    >({
      query: (body) => ({
        url: `${eventsBaseUrl}/blast_email`,
        method: 'POST',
        body,
      }),
    }),
    getParticipantCountForEvent: builder.query<{ participantCount: number }, number>({
      query: (eventId) => ({
        url: `${eventsBaseUrl}/${eventId}/participants/count`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useDeleteEventByIdMutation,
  useEventByIdQuery,
  useEventBlastEmailMutation,
  useGenerateQRCodeMutation,
  useLazyGetParticipantCountForEventQuery,
  useSaveEventMutation,
  useTableListsQuery,
} = eventsApi;
